<div class="page-layout carded left-sidenav toolbar-fixed-layout">
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container w-p-100 flex flex-row justify-start items-center">
      <particle-select-basket (basketChange)="onBasketChange($event)" class="m-r-20"></particle-select-basket>
      <particle-breadcrumbs [breadcrumbs]="breadcrumbs"></particle-breadcrumbs>
    </div>
  </div>
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
      <label class="component-label"> Actions</label>
      <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="createCase()"
                  particleAnalytics
                  analyticsCategory="entity-transactions-content"
                  analyticsAction="add-section"
          >Create Case
          </button>

          <div class="toolbar-separator"></div>
        </div>
        <!--          <div class="button-container" fxLayout="row" fxLayoutAlign="start center">-->
        <!--            <particle-grid-apply-filter *ngIf="applyFilterId" [filterId]="applyFilterId"-->
        <!--                                        [endpointName]="endpoint"-->
        <!--                                        [invalidateSubject] = "invalidateSubject">-->
        <!--            </particle-grid-apply-filter>-->

        <!--            <div class="toolbar-separator m-l-10"></div>-->
        <!--          </div>-->
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="export()"
                  particleAnalytics
                  analyticsCategory="entity-transactions-content"
                  analyticsAction="add-section"
          >Export
          </button>

          <div class="toolbar-separator"></div>
        </div>
      </div>
    </div>
  </div>

  <mat-sidenav-container>

    <!-- CENTER -->
    <div class="center">
      <!-- CONTENT CARD -->
      <div particleHelpNotes helpNoteId="dac6-overview" class="content-card mat-white-bg">
        <!-- CONTENT TOOLBAR -->
        <div class="content  pos-relative m-30 flex flex-col full-grow-no-shrink-no-basis">
          <div class="keno-grid-container">
            <particle-virtual-grid [sourceKey]="sourceType"
                                   [invalidateSubject]="invalidateSubject"
                                   (valueChanged)="onGridCellValueChange($event)"
                                   sortFieldKey="CaseId"
                                   sortDirection="desc"
                                   prefixSortFieldKey="FieldValues."
                                   [sortEnabled]="true"
                                   serviceName="CaseDynamicItemService"
                                   api="DAC6Api"
            >
            </particle-virtual-grid>
          </div>
        </div>
      </div>
      <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

  </mat-sidenav-container>

</div>
